import catalog from 'apis/catalog';

import { RawCatalogAPIData } from 'types/catalog_types';

export const allShallow = async () => {
  const { data } = await catalog.get<RawCatalogAPIData[]>('/templates.json?shallow=true');
  return data;
};

// Used in link generator -- slow, so don't use it for anything customer facing
export const allDeep = async () => {
  const { data } = await catalog.get<RawCatalogAPIData[]>('/templates.json');
  return data;
};
